import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function Privatlivspolitik() {
  return (
    <LegalLayout
      title="Privatlivspolitik for Moon Yoga"
      lastUpdated="27.07.2026"
      path="/privatlivspolitik"
    >
      <div className="bg-brand-light-gold/30 border border-brand-primary/10 rounded-2xl p-6 mb-8">
        <p className="text-base text-brand-text leading-relaxed">
          Hos Moon Yoga passer vi godt på dine personoplysninger. Når du bliver medlem, booker et hold, deltager i en Moon Gathering, køber en behandling eller besøger vores hjemmeside, betror du os nogle oplysninger om dig. Vi behandler dem med respekt, fortrolighed og i overensstemmelse med databeskyttelsesforordningen, GDPR, og den danske databeskyttelseslov. Nedenfor kan du læse, hvilke oplysninger vi indsamler, hvorfor vi gør det, og hvilke rettigheder du har.
        </p>
      </div>

      <section className="space-y-3 bg-brand-surface border border-brand-primary/10 rounded-2xl p-6">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          1. Dataansvarlig
        </h2>
        <div className="space-y-1 text-sm font-medium">
          <p className="font-serif font-semibold text-base">Moon Yoga Fredericia</p>
          <p>Dalegade 61B</p>
          <p>7000 Fredericia</p>
          <p>CVR: 46719395</p>
          <p className="pt-2">
            E-mail: {' '}
            <a href="mailto:yoga@moonyoga-fredericia.dk" className="text-brand-primary hover:underline">
              yoga@moonyoga-fredericia.dk
            </a>
          </p>
          <p>
            Telefon: {' '}
            <a href="tel:+4522393836" className="text-brand-primary hover:underline">
              22 39 38 36
            </a>
          </p>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          2. Hvilke oplysninger indsamler vi?
        </h2>
        <p>
          Vi indsamler kun de oplysninger, som er nødvendige for at kunne tilbyde vores ydelser.
        </p>
        <p>Det kan blandt andet være:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>Navn</li>
          <li>Adresse</li>
          <li>Telefonnummer</li>
          <li>E-mailadresse</li>
          <li>Fødselsdato</li>
          <li>Medlemskab</li>
          <li>Bookinghistorik</li>
          <li>Køb og betalinger</li>
          <li>Deltagelse på Moon Gatherings</li>
          <li>Køb af behandlinger, Moon Treatments</li>
          <li>Kommunikation med os via e-mail eller sociale medier</li>
        </ul>
        <p>Vi beder ikke om flere oplysninger end nødvendigt.</p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          3. Hvor får vi oplysningerne fra?
        </h2>
        <p>De fleste oplysninger giver du selv, når du:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>Opretter en profil</li>
          <li>Køber medlemskab</li>
          <li>Booker hold</li>
          <li>Køber klippekort</li>
          <li>Tilmelder dig nyhedsbrev</li>
          <li>Kontakter os</li>
          <li>Deltager i vores aktiviteter</li>
        </ul>
        <p>
          Vi kan desuden modtage oplysninger fra vores samarbejdspartnere, hvis det er nødvendigt for at gennemføre en betaling eller administrere dit medlemskab.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          4. Hvad bruger vi oplysningerne til?
        </h2>
        <p>Vi behandler dine oplysninger for at kunne:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>Administrere dit medlemskab</li>
          <li>Håndtere booking og aflysninger</li>
          <li>Gennemføre betalinger</li>
          <li>Sende praktiske informationer om dine bookinger</li>
          <li>Besvare henvendelser</li>
          <li>Udsende nyhedsbreve, hvis du har givet samtykke</li>
          <li>Forbedre vores hjemmeside og services</li>
          <li>Overholde gældende lovgivning, herunder bogføringsloven</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          5. Behandlingsgrundlag
        </h2>
        <p>Vi behandler dine personoplysninger på baggrund af:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>Opfyldelse af en aftale, GDPR artikel 6, stk. 1, litra b</li>
          <li>Vores legitime interesse i at drive Moon Yoga, artikel 6, stk. 1, litra f</li>
          <li>Dit samtykke, når dette er nødvendigt, eksempelvis ved nyhedsbreve eller brug af billeder, artikel 6, stk. 1, litra a</li>
          <li>Lovgivning, eksempelvis bogføringsloven, artikel 6, stk. 1, litra c</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          6. Booking og medlemskab
        </h2>
        <p>
          Vi anvender YOGO til administration af medlemskaber, booking og holdplan.
        </p>
        <p>
          Når du opretter en profil hos Moon Yoga, behandles dine oplysninger også gennem YOGO.
        </p>
        <p>
          YOGO behandler oplysningerne som databehandler på vores vegne og i overensstemmelse med gældende databeskyttelsesregler.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          7. Betaling
        </h2>
        <p>
          Betalinger håndteres gennem vores betalingsudbydere.
        </p>
        <p>
          Moon Yoga har ikke adgang til dine fulde betalingskortoplysninger.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          8. Nyhedsbrev
        </h2>
        <p>
          Hvis du tilmelder dig vores nyhedsbrev, bruger vi din e-mailadresse til at sende inspiration, nyheder, tilbud og information om Moon Yoga.
        </p>
        <p>
          Du kan altid afmelde dig via linket nederst i nyhedsbrevet eller ved at kontakte os.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          9. Cookies
        </h2>
        <p>
          Vi anvender cookies på vores hjemmeside for at sikre, at siden fungerer korrekt, forbedre brugeroplevelsen og indsamle anonym statistik.
        </p>
        <p>
          Du kan til enhver tid ændre eller trække dit samtykke tilbage via vores cookiebanner.
        </p>
        <p>
          Du kan læse mere i vores cookiepolitik. <em>(Særskilt cookiepolitik-side findes ikke på hjemmesiden på nuværende tidspunkt).</em>
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          10. Deling af oplysninger
        </h2>
        <p>
          Vi sælger aldrig dine personoplysninger.
        </p>
        <p>
          Vi deler kun oplysninger med samarbejdspartnere, når det er nødvendigt for at levere vores ydelser.
        </p>
        <p>Det kan eksempelvis være:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>YOGO, booking og medlemsadministration</li>
          <li>Betalingsudbydere</li>
          <li>Regnskabssystem</li>
          <li>Nyhedsbrevssystem</li>
          <li>Hjemmesidehosting</li>
        </ul>
        <p>
          Alle databehandlere er underlagt databehandleraftaler og må kun behandle oplysninger efter vores instrukser.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          11. Hvor længe opbevarer vi oplysningerne?
        </h2>
        <p>
          Vi opbevarer kun dine oplysninger, så længe det er nødvendigt.
        </p>
        <p>Generelt gælder:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>Medlemsoplysninger opbevares, så længe medlemskabet er aktivt</li>
          <li>Bogføringsoplysninger opbevares i fem år i henhold til bogføringsloven</li>
          <li>Nyhedsbrevssamtykker slettes ved afmelding</li>
          <li>Øvrige oplysninger slettes eller anonymiseres, når de ikke længere er nødvendige</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          12. Billeder og video
        </h2>
        <p>
          Ved enkelte arrangementer kan der blive taget billeder eller optaget video til brug på vores hjemmeside og sociale medier.
        </p>
        <p>
          Hvis billederne har fokus på enkeltpersoner, indhenter vi altid dit samtykke, før materialet anvendes.
        </p>
        <p>
          Ved situationsbilleder fra arrangementer tager vi hensyn til deltagernes privatliv, og du er altid velkommen til at gøre os opmærksom på, hvis du ikke ønsker at medvirke.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          13. Dine rettigheder
        </h2>
        <p>Du har til enhver tid ret til:</p>
        <ul className="list-disc pl-6 space-y-1 text-brand-text/90">
          <li>At få indsigt i de oplysninger, vi har om dig</li>
          <li>At få rettet urigtige oplysninger</li>
          <li>At få slettet oplysninger, når lovgivningen tillader det</li>
          <li>At få begrænset behandlingen</li>
          <li>At gøre indsigelse mod behandlingen</li>
          <li>At få udleveret dine oplysninger i et almindeligt anvendt format, dataportabilitet</li>
          <li>At trække et samtykke tilbage</li>
        </ul>
        <p>
          Hvis du ønsker at gøre brug af dine rettigheder, er du altid velkommen til at kontakte os.
        </p>
      </section>

      <section className="space-y-3 bg-brand-light-gold/20 border border-brand-primary/10 rounded-2xl p-6">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          14. Klage
        </h2>
        <p>
          Hvis du mener, at vi behandler dine personoplysninger i strid med reglerne, har du ret til at klage til:
        </p>
        <div className="text-sm font-medium space-y-1">
          <p className="font-semibold text-base">Datatilsynet</p>
          <p>Carl Jacobsens Vej 35</p>
          <p>2500 Valby</p>
          <p>
            <a
              href="https://www.datatilsynet.dk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-primary hover:underline"
            >
              www.datatilsynet.dk
            </a>
          </p>
        </div>
      </section>

      <section className="space-y-3 bg-brand-surface border border-brand-primary/10 rounded-2xl p-6">
        <h2 className="font-serif text-xl font-semibold text-brand-primary border-b border-brand-primary/10 pb-2">
          15. Kontakt
        </h2>
        <p>
          Har du spørgsmål til vores behandling af personoplysninger, er du altid velkommen til at kontakte os.
        </p>
        <div className="space-y-1 text-sm font-medium pt-1">
          <p className="font-serif font-semibold text-base">Moon Yoga</p>
          <p>
            E-mail: {' '}
            <a href="mailto:yoga@moonyoga-fredericia.dk" className="text-brand-primary hover:underline">
              yoga@moonyoga-fredericia.dk
            </a>
          </p>
          <p>
            Telefon: {' '}
            <a href="tel:+4522393836" className="text-brand-primary hover:underline">
              22 39 38 36
            </a>
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
